class AvisoItem {
  constructor() {
    this.id = '';
    this.idCliente = '';
    this.pergunta = '';
    this.resposta = '';
    
    this.idAssunto = '';
  }
}

export default AvisoItem